// extracted by mini-css-extract-plugin
export var legendIndicator = "_eu-1";
export var legendRight = "_eu-0";